import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Navbar from "./pages/navbar";
import Footer from "./pages/footer";
import './App.css'
import PagesContainer from "./pages/pagesContainer";
import DetailsPage from "./pages/detailsPage";
import DynamicFavicon from "./components/dynamicFavicon";
import Cookies from "./pages/cookies";

const App = () => {
    return (
        <Router>
            <DynamicFavicon />
            <Navbar />
            <div className="page-container">
                    <Routes>
                        <Route path="/:slug" element={<PagesContainer />} />
                        <Route path="/" element={<PagesContainer />} />
                        <Route path="/:slug/details/:id" element={<DetailsPage />} />
                    </Routes>
            </div>
            <Footer />
            <Cookies/>
        </Router>
    );
};

export default App;
